import { styled } from "@mui/material/styles";
import { Button, Chip } from "@mui/material";
import { useColors } from "../../../../Context/ColorsContext";
import { MediaQuerys } from "../../../../styles/GlobalStyle";


const { mobile, tablet, desktop, desktoplarge } = MediaQuerys;

export const Container = styled('div')(({theme}) => ({
  display: 'flex',
  width: '100%',
  height: '100%',
  flexDirection: 'column',
  [theme.breakpoints.up('md')]: {
    width: '400px'
  },
  [theme.breakpoints.up('lg')]: {
    width: '500px'
  },
  [theme.breakpoints.down('md')]: {
    width: '350px'
  },
}))

export const Header = styled('div')(() => {
  const { colors } = useColors();
  return {
    display: 'flex',
    background: colors.white,
    color: colors.sidebarSelectColor,
    width: '100%',
    height: 'fit-content',
    borderRadius:'10px 10px 0 0',
    padding:'16px',
    textTransform:'uppercase',
    fontWeight:600,
    borderBottom: `1px solid ${colors.gray}`,
    [desktop]: {
      fontSize:'0.95rem',
    }
  }
})

export const Body = styled('div')(() => {
  const { colors } = useColors();
  return {
    display: 'flex',
    flexDirection:'column',
    flex:'1',
    width: '100%',
    background: colors.white,
  }
})

export const Footer = styled('div')(() => {
  const { colors } = useColors();
  return {
    display: 'flex',
    background: colors.white,
    width: '100%',
    height: 'fit-content',
    borderRadius:'0 0 10px 10px',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '8px 16px',
    margin: 'auto'
  }
})

function buttonType(type) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { colors } = useColors();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    if (type === 'cancel') return colors.white
    // eslint-disable-next-line react-hooks/rules-of-hooks
    if (type === 'close') return colors.white
    // eslint-disable-next-line react-hooks/rules-of-hooks
    if (type === 'delete') return colors.red
    // eslint-disable-next-line react-hooks/rules-of-hooks
    if (type === 'download') return colors.sidebarSelectColor
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return colors.buttonActionColor
}

export const DownloadButton = styled(Button)(({type}) => {
    const { colors } = useColors();
    return {
        height: 30,
        width: '100%',
        // padding: "0 20px",
        background: buttonType(type),
        color: `${type !== 'cancel' && type !== 'close' ? colors.white : colors.buttonActionColor}`,
        border: `1px solid ${type === 'download' ? colors.sidebarSelectColor : colors.buttonActionColor}`,
        "&:hover": {
            background: buttonType(type),
            borderColor: `1px solid ${type === 'download' ? colors.sidebarSelectColor : colors.buttonActionColor}`,
            opacity: 0.9
        }
    }
})

export const ContainerButtonCreate = styled('div')(() => ({
	width: 170,
	height: 40,
	[desktop]: {
		width: "150px",
		height: "30px",
		"& button": {
			padding: "14px 12px",
			fontSize: "0.55rem",
		},
	},
	[tablet]: {
		width: "110px",
		height: 20,
		"& button": {
			fontSize: "7px",
		},
	},
}))

export const CustomChip = styled(Chip)(() => {
    const { colors } = useColors();
    return {
        height: 'auto',
        background: "#CCF7DA",
        borderRadius: '20px',
        padding: "2px 10px",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",

        "& .MuiChip-label": {
          padding: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        },
    }
})

export const TextType = styled('span')(() => {
    const { colors } = useColors();

    return {
      fontSize: "0.9rem",
      fontWeight: 600,
      color: colors.buttonActionColor,
      letterSpacing: "0.3px",
      textAlign: "center",
      lineHeight: 1.2,
    }
})

export const Title = styled('span')(() => {
    const { colors } = useColors();

    return {
      fontSize: "1.8rem",
      fontWeight: 600,
      color: colors.black,
      letterSpacing: "0.3px",
      textAlign: "center",
      lineHeight: 1.2
    }
})

export const Subtitle = styled('span')(() => {
    const { colors } = useColors();

    return {
      fontSize: "0.8rem",
      fontWeight: 600,
      color: colors.buttonActionColor,
      letterSpacing: "0.3px",
      textAlign: "center",
      lineHeight: 1.2,
      marginTop: 5
    }
})
